import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import hexRgb from 'hex-rgb';
import camo from '../../images/camo.gif';
import camoSmall from '../../images/camo_small.gif';
import heathered from '../../images/heathered.gif';
import heatheredSmall from '../../images/heathered_small.gif';
import tiedye from '../../images/tiedye.gif';
import tiedyeSmall from '../../images/tiedye_small.gif';
var hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
export var getBackground = function (size, color, special) {
    switch (special) {
        case 'camo':
            return size === 'large'
                ? { backgroundImage: "url(".concat(camo, ")") }
                : { backgroundImage: "url(".concat(camoSmall, ")") };
        case 'heathered':
            return size === 'large'
                ? { backgroundImage: "url(".concat(heathered, ")") }
                : { backgroundImage: "url(".concat(heatheredSmall, ")") };
        case 'tiedye':
            return size === 'large'
                ? { backgroundImage: "url(".concat(tiedye, ")") }
                : { backgroundImage: "url(".concat(tiedyeSmall, ")") };
        default:
            return color && color.match(hexRegex) ? { backgroundColor: color } : {};
    }
};
export var getRgb = function (color) {
    if (!color ||
        typeof color !== 'string' ||
        (typeof color.match === 'function' && !color.match(hexRegex))) {
        return undefined;
    }
    var rgb = hexRgb(color);
    return rgb
        ? {
            r: rgb.red,
            g: rgb.green,
            b: rgb.blue,
        }
        : undefined;
};
export var getContrastColor = function (hexFallback, rgb) {
    rgb = rgb !== null && rgb !== void 0 ? rgb : { r: 255, g: 255, b: 255 };
    // https://stackoverflow.com/a/41491220 - Equation pulled and modified from here
    return 0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b < 179
        ? designTokens.color.shade.white.value
        : hexFallback;
};
export var checkmarkContrast = function (rgb, special) {
    if (special) {
        return designTokens.color.shade.white.value;
    }
    else {
        return getContrastColor(designTokens.color.shade.black.value, rgb);
    }
};
export var subtletyContrast = function (rgb, special) {
    if (special) {
        return designTokens.color.shade.white.value;
    }
    else {
        return getContrastColor(designTokens.color.gray.slateDark.value, rgb);
    }
};
//# sourceMappingURL=colors.js.map